
import { Component, Vue } from 'vue-property-decorator'
import { ClueService } from '@/services'
import { addImgHost } from '@/common/utils'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

@Component({
    name: 'release-detail',
    components: {
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private isLoading = true
    private detailId = ''
    private detail: any = {
        status: 0,
        title: '',
        cover_img: '',
        start_at: '',
        end_at: '',
        province: '',
        city: '',
        location: '',
        created_at: '',
        typeName: '',
        userId: '',
        userName: '',
        images: ''
    }

    get coverImgUrl() {
        return this.detail.cover_img ? addImgHost(this.detail.cover_img) : ''
    }

    get imageList() {
        if (!this.detail.images) return []
        try {
            const images = typeof this.detail.images === 'string'
                ? JSON.parse(this.detail.images)
                : this.detail.images
            return images.map((img: string) => addImgHost(img))
        } catch {
            return []
        }
    }

    private created() {
        this.$title('Loading | 详情页 - 庖丁')
        this.detailId = this.$route.params.id
    }

    private async mounted() {
        await this.getDetail()
    }

    get matchStatus() {
        const status = {
            1: '审核中',
            2: '已通过',
            3: '不通过'
        }
        return Reflect.get(status, this.detail.status)
    }

    private matchButtonType(status: number) {
        return this.detail.status === status ? 'primary' : 'default'
    }

    /** 获取详情 */
    private async getDetail() {
        const params = {
            id: +this.detailId
        }
        try {
            const result = await ClueService.getReleaseDetail(params)
            if (result.status === 200) {
                const data = result.data
                // 映射 API 字段到模板使用的格式
                this.detail = {
                    status: data.status || 0,
                    title: data.title || '',
                    cover_img: data.coverImg || '',
                    start_at: data.startAt || '',
                    end_at: data.endAt || '',
                    province: data.province || '',
                    city: data.city || '',
                    location: data.location || '',
                    created_at: data.createdAt || '',
                    typeName: data.typeName || '',
                    userId: data.userId || '',
                    userName: data.userName || '',
                    images: data.images || ''
                }
                this.$title(`${this.detail.title} | 发布会详情 - 庖丁`)
            }
        } catch (err) {
            console.error('获取详情失败:', err)
        } finally {
            this.isLoading = false
        }
    }

    // 改变状态
    private async changeStatus(status: number) {
        const params = {
            id: +this.detailId,
            status
        }
        const result = await ClueService.updateRelease(params)
        if (result.status === 200) {
            this.detail.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }
}
